export default {
	state: () => ({
		unreadMessages: [],
		usernameResources: [],
		configjsonRequiredNotify: false,
		configjsonRequired: "",
		// Variables para detectar las notificaciones a traves de sus incrementos
		availableEvents: 0,
		aceptedEvents: 0,
		aceptedEventNotification: 0,
		aceptedEventNotificationEnable: true,
		readAvalibleEventsNotificationTrigger: 0,
		requiredPermissions: {
			trigger: 0,
			data: null,
		},
		communicationMesaagesReload: 0,
		deleteNotificationTrigger: 0,
		reloadNotificationTrigger: 0,
	}),
	actions: {
		showConfigjsonRequiredNotify({state, commit}, dataFromRoute) {
			commit("changeConfigjsonRequiredNotify", dataFromRoute);
		},
	},
	mutations: {
		setReadAvalibleEventsNotificationTrigger(state) {
			state.readAvalibleEventsNotificationTrigger = state.readAvalibleEventsNotificationTrigger + 1;
		},
		setUnreadMessages(state, unreadMessages) {
			state.unreadMessages = unreadMessages;
		},
		setUsernameResources(state, usernameResources) {
			state.usernameResources = usernameResources;
		},
		setAvailableEvents(state, num = 1) {
			state.availableEvents = num === -1 ? state.availableEvents - 1 : state.availableEvents + 1;
		},
		resetAvailableEventsNotification(state) {
			state.availableEvents = 0;
		},
		setAceptedEvents(state, notification) {
			state.aceptedEvents = state.aceptedEvents + 1;
			state.aceptedEventNotification = notification.body;
		},
		changeConfigjsonRequiredNotify(state, val) {
			state.configjsonRequiredNotify = !state.configjsonRequiredNotify;
			state.configjsonRequired = val.name;
		},
		changeAceptedEventNotificationEnable(state, val) {
			state.aceptedEventNotificationEnable = val;
		},
		setRequiredPermissions(state, data) {
			state.requiredPermissions.trigger = state.requiredPermissions.trigger + 1;
			state.requiredPermissions.data = data;
		},
		setCommunicationMesaagesReload(state, data) {
			state.communicationMesaagesReload = state.communicationMesaagesReload + 1;
		},
		setReloadNotificationTrigger(state) {
			state.reloadNotificationTrigger = state.reloadNotificationTrigger + 1;
		},
	},
	getters: {
		getConfigjsonRequiredNotifyStatus: (state) => () => {
			return state.configjsonRequiredNotify;
		},
		getConfigjsonRequiredName: (state) => () => {
			return state.configjsonRequired;
		},
		getTotalUnreadMessages: (state) => {
			return state.unreadMessages.length;
		},
		getUsernameResources: (state) => {
			return state.usernameResources;
		},
		getTotalAvailableEvents: (state) => {
			return state.availableEvents;
		},
		getAceptedEvents: (state) => {
			return state.aceptedEvents;
		},
		getAceptedEventNotification: (state) => {
			return state.aceptedEventNotification;
		},
		getReadAvalibleEventsNotificationTrigger: (state) => {
			return state.readAvalibleEventsNotificationTrigger;
		},
		getReadMessageNotificationTrigger: (state) => {
			return state.communicationMesaagesReload;
		},
		getAceptedEventNotificationEnable: (state) => {
			return state.aceptedEventNotificationEnable;
		},
		getRequiredPermissionsTrigger: (state) => {
			return state.requiredPermissions.trigger;
		},
		getRequiredPermissionsData: (state) => {
			return state.requiredPermissions.data;
		},
		getDeleteNotificationTrigger: (state) => {
			return state.deleteNotificationTrigger;
		},
		getReloadNotificationTrigger: (state) => {
			return state.reloadNotificationTrigger;
		},
	},
};
